import { connect } from 'react-redux';
import { getNotesCount } from '../../../publicSession/selectors';
import { getUnreadChatsCount } from '../../../Notes/redux/unreadChats/selectors';
const mapStateToProps = (state)=>({
        unreadCount: getUnreadChatsCount(state) + getNotesCount(state)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
